export default "__VITE_ASSET__BRRFNkJD__"